/*
	Pure helpers for the Capacitor shell (src/lib/native.js). Kept free of Capacitor imports so
	they can be unit tested in node.
*/

// PayPal's checkout button needs a real popup it can talk to (window.opener); an in-app
// browser tab would leave the button waiting. Those stay with the web view.
const POPUP_HOSTS = /(^|\.)paypal\.com$|(^|\.)paypalobjects\.com$/i

/**
 * The http(s) URL to open in the in-app browser, or null when the web view should handle it
 * (same-app routes, non-web schemes like tel: and mailto:, PayPal).
 * @param {string} href
 * @param {string} base current page URL
 */
export function externalUrl(href, base) {
	if (!href || typeof href !== 'string') return null
	let url, current
	try {
		current = new URL(base)
		url = new URL(href, current)
	} catch {
		return null
	}
	if (!/^https?:$/.test(url.protocol)) return null
	if (url.host === current.host) return null
	if (POPUP_HOSTS.test(url.hostname)) return null
	return url.href
}

// 'rgb(23, 19, 27)' (theme.js) -> '#17131b' (StatusBar.setBackgroundColor). Null if unreadable.
export function hexColor(value) {
	const match = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/.exec(value || '')
	if (!match) return null
	return '#' + match.slice(1).map((n) => Math.min(255, Number(n)).toString(16).padStart(2, '0')).join('')
}
